import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Ip, IpIpify, IpLocalizaIP } from '@shared/models/interfaces/ip.interface';

import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class IpService {
  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private translateService: TranslateService
  ) {}

  public async getIPAddress(): Promise<Ip> {
    try {
      const listRequests: string[] = [
        'https://api.ipify.org/?format=json',
        'https://www.localizaip.com.br/api/iplocation.php',
      ];
      for (const request of listRequests) {
        const ip: Ip = await Promise.race<Ip>([
          this.utilsService.timeoutToReject<Ip>('IP Service timeout reached', 6000),
          this.http.get<IpIpify | IpLocalizaIP>(request).toPromise(),
        ]).catch(() => {
          return { ip: null };
        });
        if (ip.ip) {
          return ip;
        }
      }
      throw new Error('IP Service error');
    } catch (error) {
      console.error(error);
      this.utilsService
        .showToast('', `${this.translateService.instant('PROVIDERS.WE_CANT_GET_IP')}`)
        .then(() => {
          setTimeout(() => {
            this.utilsService.showToast(
              '',
              `${this.translateService.instant('PROVIDERS.PLEASE_VERIFY_BLOCK')}`,
              12000,
              'middle'
            );
          }, 750);
        });
      return <Ip>{};
    }
  }
}
